import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import { get } from 'lodash';

import { tipsterActions } from './actions';
import {
  TIPSTER_FAILURE,
  TIPSTER_REQUEST,
  TIPSTER_SUCCESS,
} from '../../constants/tipster';

export type TipsterState = {
  data: any;
  isLoading: boolean;
  error: string | null;
};
export type TipsterActions = ActionType<typeof tipsterActions>;

export const tipsterReducer = combineReducers<TipsterState, TipsterActions>({
  data: (state = null, action) => {
    switch (action.type) {
      case TIPSTER_SUCCESS:
        return {
          tipster: get(action.payload, ['tipster']),
          tipsterStats: get(action.payload, ['tipster_stats']),
        };
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case TIPSTER_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case TIPSTER_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
